import Repository from './Repository';

const resource = '';

export default class SchoolsService {
  constructor(storage) {
    this.storage = storage;
  }

  formatNumber(value) {
    if (typeof value === 'object') {
      Object.keys(value).forEach(key => {
        value[key] = this.formatNumber(value[key]);
      });
      return value;
    }
    if (typeof value === 'string' && !isNaN(value)) {
      let parsed = parseFloat(value);
      if (isNaN(parsed) || parsed % 1 === 0) {
        return value;
      }
      value = parsed;
    }
    if (typeof value !== 'number' || value % 1 === 0) {
      return value;
    }
    return value.toFixed(1);
  }
  formatSchool(school) {
    [
      'chartData',
      'esl',
      'french_immersion',
      'special_needs',
      'reportCardData',
      'reportCardDataBottom',
    ].forEach((key) => {
      if (school.hasOwnProperty(key)) {
        if (typeof key === 'object') {
          this.formatNumber(school[key]);
        }
        else {
          school[key] = this.formatNumber(school[key]);
        }
      }
    })
  }
  async getSchoolLocations(province) {
    let latestYear = this.storage.getItem('latestYear');
    latestYear = JSON.parse(latestYear);



    let url = `${resource}/schools.json?province=${province}`;

    let schools = [];
    // Filter by province
    let schoolsByProvince = await Repository.get(url).catch((e) => {
      // eslint-disable-next-line no-console
      console.error(e);
    });
    for(let i = schoolsByProvince.data.data.length - 1; i >= 0; i--) {
      let singleSchool = {};
      singleSchool.province = schoolsByProvince.data.data[i].province;
      singleSchool.sid = schoolsByProvince.data.data[i].sid;
      singleSchool.title = schoolsByProvince.data.data[i].title;
      singleSchool.level = schoolsByProvince.data.data[i].schoolType;
      singleSchool.ranking = schoolsByProvince.data.data[i]["schoolInfoData"]["Rank This Yr"];

      let currentYear = latestYear[singleSchool.province + '_' + singleSchool.level];
      singleSchool.score = schoolsByProvince.data.data[i]["schoolInfoData"][currentYear];

      singleSchool.city = schoolsByProvince.data.data[i]["schoolInfoData"]["SchoolCity"];
      singleSchool["IND_or_PUB"] = schoolsByProvince.data.data[i]["schoolInfoData"]["IND_or_PUB"];
      singleSchool.location = {};
      if (schoolsByProvince.data.data[i]["contactData"] && schoolsByProvince.data.data[i]["contactData"]["coords"]) {
        singleSchool.location.lat = schoolsByProvince.data.data[i]["contactData"]["coords"]["lat"];
        singleSchool.location.lon = schoolsByProvince.data.data[i]["contactData"]["coords"]["long"];
      }
      else {
        singleSchool.location = null;
      }
      let trends = {
        "112233": 1,
        '%u2014': 0,
        "998855": -1
      };
      singleSchool.trend = trends[escape(schoolsByProvince.data.data[i].schoolInfoData["Direction"])];
      singleSchool.areaName = schoolsByProvince.data.data[i]["schoolInfoData"]["AreaName"];
      singleSchool.adminBodyName = schoolsByProvince.data.data[i]["schoolInfoData"]["AdminBodyName"];
      singleSchool.language = schoolsByProvince.data.data[i]["schoolInfoData"]["SchoolLanguage"];
      if (schoolsByProvince.data.data[i]["contactData"] && schoolsByProvince.data.data[i]["contactData"]["Postal Code"]) {
        singleSchool.postalCode = schoolsByProvince.data.data[i]["contactData"]["Postal Code"];
      }
      else {
        singleSchool.postalCode = null;
      }

      schools.push(singleSchool);
    }

    this.storage.setItem('schoolData', JSON.stringify(schools));
    //document.getElementsByClassName('application--wrap')[0].classList = 'application--wrap';
    // Filter by province
    return schools.filter(
      function (e) {
        return e.province === province;
      }
    );
  }
  getSchoolsByPolygon(topRightCorner, bottomLeftCorner) {
    let url = `${resource}/schools.json?topRight=${topRightCorner}&bottomLeft=${bottomLeftCorner}`;

    return Repository.get(url).catch((e) => {
      // eslint-disable-next-line no-console
      console.log(e);
    });
  }
  async getById(id, level, province) {
    let url = `${resource}/school.json?sid=${id}&level=${level}&province=${province}`;
    let school = await Repository.get(url).catch((e) => {
      // eslint-disable-next-line no-console
      console.log(e);
    });

    let schoolData = school.data.data;
    let schoolByLevel = schoolData.filter(item => {
      return item.schoolType == level;
    });

    if (schoolByLevel.length > 0) {
      return await this.prepareStructureSchool(schoolByLevel[0]);
    }
    else {
      return null;
    }
  }
  prepareStructureSchool(school) {
    school.id = school.sid;
    if (typeof school["contactData"] == 'string') {
      school.contactData = JSON.parse(school["contactData"]);
    }
    if (typeof school["schoolInfoData"] == 'string') {
      school.schoolInfoData = JSON.parse(school["schoolInfoData"]);
    }
    if (typeof school["reportCardData"] == 'string') {
      school.reportCardData = JSON.parse(school["reportCardData"]);
    }

    let latestYear = this.storage.getItem('latestYear');
    latestYear = JSON.parse(latestYear);
    let score = school.schoolInfoData[latestYear[school.province + '_' + school.schoolType]];

    // 112233 is up
    // \\u2014 is dash
    // 998855 is down
    let trends = {};
    trends["112233"] = 1;
    trends['%u2014'] = 0;
    trends["998855"] = -1;
    let trend = trends[escape(school.schoolInfoData["Direction"])];
    let address;
    let coords = {};
    if (school.contactData) {
      address = school.contactData.Address;
      if (school.contactData["City"]) {
        address += ", " + school.contactData["City"];
      }
      if (school.contactData["Province"]) {
        address += ", " + school.contactData["Province"];
      }

      if (school.contactData["coords"]) {
        coords.lat = school.contactData["coords"]["lat"];
        coords.lon = school.contactData["coords"]["long"];
      }
      else {
        coords = null;
      }
    }

    if (school.contactData["School Website"]) {
      school.website = school.contactData["School Website"];
    }

    if (school.reportCardData) {
      school.reportCardData.forEach((report, index) => {
        let label = report["IndexDesc"].split(":");
        if (label.length >= 2) {
          school.reportCardData[index]["label"] = label[0];
          school.reportCardData[index]["IndexDesc"] = label[1];
        }
        else {
          school.reportCardData[index]["IndexDesc"] = label[0].trim();
        }
      });
    }

    school.coords = coords;
    school.trend = trend;
    school.score = score;
    school.fullAddress = address;
    this.prepareChartData(school);
    this.formatSchool(school);

    return school;
  }
  async getSchoolAreaNameByProvince(province, schoolEducationLevel, skipUpdate) {
    let url = `${resource}/schools_area_names.json`;

    // Filter by province
    if(!skipUpdate) {
      Repository.get(url).then(data => {
        this.storage.setItem('areaNames', JSON.stringify(data.data.data));
      }).catch((e) => {
        // eslint-disable-next-line no-console
        return console.error(e);
      });
    }

    let areaNamesLocal = this.storage.getItem('areaNames');

    if (areaNamesLocal !== null) {
      areaNamesLocal = JSON.parse(areaNamesLocal);
      // Filter by province

      let areaNamesFiltered = areaNamesLocal.filter(
        function(e) {
          return e.province === province && e[schoolEducationLevel];
        }
      );

      return areaNamesFiltered.map(function (area) {
        return area['adminBodyName'] ?? area['areaName'];
      });
    }
    else {
      // Filter by province
      return Repository.get(url).then(data => {
        this.storage.setItem('areaNames', JSON.stringify(data.data.data));
        let areaNamesFiltered = data.data.filter(
          function(e) {
            return e.province === province && e[schoolEducationLevel];
          }
        );
        return areaNamesFiltered;
      }).catch((e) => {
        // eslint-disable-next-line no-console
        return console.error(e);
      });
    }


  }
  prepareChartData(school) {
    school.chartData = {};

    if (school['reportCardData']) {
      let reportCardDatas = school['reportCardData'].slice(
        0,
        school['reportCardData'].length - 3
      );
      let reportCardDataBottom = school['reportCardData'].slice(-3);
      let label;

      let indicator_years = [];
      if (school['schoolInfoData']) {
        Object.keys(school['schoolInfoData']).forEach(function(key) {
          if (key && !isNaN(Number(school['schoolInfoData'][key]))
                && !isNaN(Number(key))
                && school['schoolInfoData'][key] !== null) {
              indicator_years.push(key);
            }
        });
      }

      reportCardDatas.forEach(reportCardData => {
        label = reportCardData["label"] !== undefined ? reportCardData["label"] : label !== undefined ? label : '';
        let desc = reportCardData["IndexDesc"].trim();
        desc = desc !== undefined ? desc.trim() : "";
        let indexDesc = label ? label + ": " + desc : desc;
        indexDesc = indexDesc.trim();
        school.chartData[indexDesc] = {};
        indicator_years.forEach(year => {
          if (year in reportCardData) {
            school.chartData[indexDesc][year] = reportCardData[year];
          }
        });
      });
      reportCardDataBottom.forEach(reportCardData => {
        let indexDesc = reportCardData["IndexDesc"].trim();
        school.chartData[indexDesc] = {};
        indicator_years.forEach(year => {
          if (year in reportCardData) {
            school.chartData[indexDesc][year] = reportCardData[year];
          }
        });
      });
    }
  }
  async getAverageData(filter) {
    let averageData = await this.storage.getItem('schools_average');
    let url = `${resource}/schools_average.json`;
    if (averageData === null || JSON.parse(averageData).length === 0 || typeof averageData === 'undefined') {
      let averageList = await Repository.get(url).catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
      });
      averageData = averageList.data.data;
      this.storage.setItem('schools_average', JSON.stringify(averageData));
    } else {
      Repository.get(url).then((averageList) => {
        averageData = averageList.data.data;
        this.storage.setItem('schools_average', JSON.stringify(averageData));
      }).catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
      });
      averageData = JSON.parse(averageData);
    }

    let averageDataFiltered = averageData.filter(function(element) {
      let typeAndProvinceCheck = element.province.includes(filter.province)  &&
      element.schoolType.includes(filter.schoolType);
      let elementTitle = element.title.toLowerCase();
      let filterTitle = filter.title.toLowerCase();

      if (filter.province == 'qc') {
        return typeAndProvinceCheck && (elementTitle.includes(filterTitle)
          || elementTitle.includes('Cote globale (sur 10)'.toLowerCase()));
      }

      return typeAndProvinceCheck && elementTitle.includes(filterTitle);
    });
    if (averageDataFiltered) {
      return averageDataFiltered[0];
    }
    return null;
  }
}
